import React, { useEffect } from "react";
import ContentBox from "../../components/UI/ContentBox";
import Menu from "../../components/UI/Menu";
import { Container, Video, Title } from "./styles";
import Footer from "../../components/UI/Footer";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";
import courseshelp from "../../assets/videos/CoursesHelpUser.mp4";
import certificatehelp from "../../assets/videos/ajuda-certificados.mp4";


const CoursesHelpUser = () => {
  useEffect(() => {
    
  }, []);
  
  return (
    <Container>
      <Menu />
      <Banner icon={images.iconAjuda}>GUIAS FORMAÇÕES</Banner>
      <ContentBox>
        <Title>Acompanhamento das Formações</Title>
        <Video controls>
          <source src={courseshelp} type="video/mp4" />
        </Video>

        <Title>Certificado das Formações</Title>
        <Video controls>
          <source src={certificatehelp} type="video/mp4" />
        </Video>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default CoursesHelpUser;